import { createApiClient } from '@clean-code/api/client';
import { videoApiBaseUrl } from '@constants/config';

export const videoApi = createApiClient(
  {
    baseURL: videoApiBaseUrl,
    headers: {
      'Content-Type': 'application/json'
    }
  },
  {
    transformAuthToken: (token) =>
      token.trim().toLowerCase().startsWith('bearer ')
        ? token
        : `Bearer ${token}`
  }
);
